import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { isNotNullish, isNullish } from '@y42/util/nullish';

@Component({
  selector: 'y42-context-menu-font-size',
  templateUrl: './context-menu-font-size.component.html',
  styleUrls: ['./context-menu-font-size.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuFontSizeComponent implements OnChanges {
  constructor(private readonly cdRef: ChangeDetectorRef) {}

  @Input()
  fontSize?: string | number;

  @Output()
  fontSizeChanged = new EventEmitter<number>();

  fontSizeNumber = 12;

  ngOnChanges(changes: SimpleChanges) {
    if ('fontSize' in changes && isNotNullish(this.fontSize)) {
      this.parseFontSize();
    }
  }

  parseFontSize() {
    if (isNullish(this.fontSize)) {
      return;
    }
    if (isNaN(+this.fontSize)) {
      const match = this.fontSize.toString().match(/\d+/);
      this.fontSizeNumber = match ? +match[0] : 0;
    } else {
      this.fontSizeNumber = +this.fontSize;
    }
    this.cdRef.markForCheck();
  }
}
